import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { parse } from 'query-string';
import { useMemo } from 'react';
import { pure } from 'recompose';
import { CSearchProList } from '@/components/modules/pages/consultantSearch/List/CSearchProList';
import { CSearchProListItem, CSearchProListItemSkeleton, } from '@/components/modules/pages/consultantSearch/List/CSearchProListItem';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
import { propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import ConsultantSearchSolutionSlider from '../../../Ui/ConsultantSearch/Slider/ConsultantSearchSolutionSlider';
import ConsultantSearchSliderHeader from '../SliderHeader';
const ConsultantSearchAll = pure((props) => {
    const { isClient, isGuest, isLg, isMd, isNoResult, isPre, isShow, keyword, locationSearch, onChangeSearch, onClickForLinkEvent, onClickProjectCountLink, professionalPage: { initialLoaded: isProfessionalLoaded, list: professionals, }, solutionPage: { initialLoaded: isSolutionLoaded, list: solutions = [] }, } = props;
    const showRowClassName = `search_list_block_all ${isShow && !isNoResult ? '' : 'is-dnone'}`;
    const sliderConfig = useMemo(() => ({
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: solutions.length > 3,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    infinite: solutions.length > 1,
                    slidesToShow: 1,
                    variableWidth: true,
                },
            },
        ],
        slidesToShow: 3,
    }), [solutions]);
    const fillCount = isMd ? 1 : 3;
    const queryObject = useMemo(() => parse(locationSearch), [locationSearch]);
    /** スケルトン表示用のダミー配列 */
    const dummies = useArrayWithIndex(3);
    if (!isProfessionalLoaded) {
        return (_jsx("div", Object.assign({ className: showRowClassName }, { children: _jsx(CSearchProList, { children: dummies.map(({ index }) => (_jsx(CSearchProListItemSkeleton, { className: 'search_consultant_block' }, index))) }) })));
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: showRowClassName }, { children: _jsx(CSearchProList, { children: professionals.map((professional) => (_jsx(CSearchProListItem, { className: clsx('search_consultant_block'), isClient: isClient, isGuest: isGuest, isPre: isPre, onClick: onClickForLinkEvent, onClickProjectCountLink: onClickProjectCountLink, professional: professional, queryObject: queryObject }, professional.id))) }) })), !isNoResult &&
                isClient &&
                isShow &&
                isSolutionLoaded &&
                solutions.length > 0 && (_jsxs("div", Object.assign({ className: 'search_list_slider' }, { children: [_jsx(ConsultantSearchSliderHeader, { keyword: keyword, onChangeSearch: onChangeSearch, search: 'service', title: '事例' }), _jsx(ConsultantSearchSolutionSlider, { config: sliderConfig, fillCount: fillCount, isLg: isLg, isMd: isMd, isPre: isPre, showPreModal: onClickForLinkEvent, solutionLoading: !isSolutionLoaded, solutions: solutions })] })))] }));
});
ConsultantSearchAll.propTypes = {
    isClient: propBool().isRequired,
    isGuest: propBool().isRequired,
    isLg: propBool().isRequired,
    isMd: propBool().isRequired,
    isNoResult: propBool().isRequired,
    isPre: propBool().isRequired,
    isShow: propBool().isRequired,
    keyword: propStr().isRequired,
    locationSearch: propStr().isRequired,
    onChangeSearch: propFunc().isRequired,
    onClickForLinkEvent: propFunc().isRequired,
    onClickProjectCountLink: propFunc().isRequired,
    professionalPage: propShape().isRequired,
    solutionPage: propShape().isRequired,
};
export default ConsultantSearchAll;
